// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Loader_spinnerContainer__5P9tx"};